export default "__VITE_ASSET__RQwENzMS__"